module.exports = __webpack_public_path__ + "static/media/lk.f4a88527.svg";